import { render } from "./PaymentsView.vue?vue&type=template&id=3666860a&scoped=true&ts=true"
import script from "./PaymentsView.vue?vue&type=script&lang=ts"
export * from "./PaymentsView.vue?vue&type=script&lang=ts"

import "./PaymentsView.vue?vue&type=style&index=0&id=3666860a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3666860a"]])

export default __exports__